import Api from "./api";

class HandleErrorApi extends Api {
    async request(func, uri, data = null) {
        let response = {};

        try {
            response = await func(uri, data);
        } catch (e) {
            let message = e.response ? e.response.data.message : e.message;
            const error = new Error(message);
            error.status = e.response?.status;
            throw error;
        }

        return response.data || {};
    }
}

export default HandleErrorApi;
